import { LazyImage } from '@frontend/design_system'
import check from 'assets/icons/green700Master/green700Master_check_20x20.webp'
import cross from 'assets/icons/red600/red600_cross_20x20.webp'
import { APPROVE, REQUEST } from 'texts/approval'
import { useAppSelector } from 'redux/hooks'
import { Button } from 'ui/atoms/Button'
import { ApprovedModal } from './components/ApprovedModal'
import { useMemo, useState } from 'react'
import { isOperatorSelector, userDataSelector } from 'redux/login/selectors'
import { UserSection } from 'api/profile/types'
import { OPERATOR_ACTION_BUTTONS_SECTIONS } from './constants'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { RequestModal } from './components/RequestModal'
import styles from './styles.module.scss'
import { DocumentType } from 'api/documents/types'

interface IOperatorActionButtonsProps {
  companyId: string
  section: UserSection
  documentType?: keyof typeof DocumentType
  onSuccess?: () => void
}

export const OperatorActionButtons = ({
  companyId,
  section,
  documentType,
  onSuccess,
}: IOperatorActionButtonsProps) => {
  const { sectionsStatuses } = useAppSelector(userDataSelector)
  const [isVisibleApproveModal, setIsVisibleApproveModal] = useState(false)
  const [isVisibleRequestModal, setIsVisibleRequestModal] = useState(false)
  const isOperator = useAppSelector(isOperatorSelector)

  const isReady = useMemo(
    () =>
      sectionsStatuses?.[OPERATOR_ACTION_BUTTONS_SECTIONS[section]] ===
        REGISTRATION_STATUSES.REVIEW || section === 'Documents',
    [sectionsStatuses, section]
  )

  if (!isReady || !isOperator) {
    return null
  }

  const onToggleApproveModal = () =>
    setIsVisibleApproveModal((prev) => {
      if (prev && onSuccess) {
        onSuccess()
      }
      return !prev
    })

  const onToggleRequestModal = () =>
    setIsVisibleRequestModal((prev) => {
      if (prev && onSuccess) {
        onSuccess()
      }
      return !prev
    })

  return (
    <div className={styles.buttons}>
      <Button
        variant="link"
        label={REQUEST}
        size="large"
        typographyName="Button2"
        iconPosition="right"
        icon={<LazyImage src={cross} minWidth={20} height={20} />}
        onClick={onToggleRequestModal}
      />
      <Button
        variant="link"
        label={APPROVE}
        size="large"
        typographyName="Button2"
        iconPosition="right"
        icon={<LazyImage src={check} minWidth={20} height={20} />}
        onClick={onToggleApproveModal}
      />
      {isVisibleApproveModal && (
        <ApprovedModal
          onClose={onToggleApproveModal}
          companyId={companyId}
          section={section}
          documentType={documentType}
        />
      )}
      {isVisibleRequestModal && (
        <RequestModal
          onClose={onToggleRequestModal}
          companyId={companyId}
          section={section}
          documentType={documentType}
        />
      )}
    </div>
  )
}
